import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { Button, Modal } from 'antd'

import AlertIcon from '../../assets/images/ico_erro.svg'
import { getMessage } from '../../util/IntlMessages'

import './ConfirmLeaveWithoutSavingModal.css'

export function ConfirmLeaveWithoutSavingModal({
  when,
  saveAction,
  leaveRoute,
  isSubmitting,
  forceVisibility = false,
  setForceVisibility = () => {},
  leaveWithoutSavingCleanup
}) {
  const history = useHistory()

  const [visible, setVisible] = useState(false)
  const [pendingLocation, setPendingLocation] = useState(null)
  const unblockRef = useRef(null)

  /**
   * Possibilita abertura do modal mesmo que a rota não seja alterada
   */
  useEffect(() => {
    if (forceVisibility) setVisible(true)
  }, [forceVisibility, when])

  /**
   * Bloqueia navegação interna
   */
  useEffect(() => {
    if (!when) return

    unblockRef.current = history.block((location) => {
      setPendingLocation(location)
      setVisible(true)
      return false
    })

    return () => {
      unblockRef.current?.()
      unblockRef.current = null
    }
  }, [when, history])

  /**
   * Bloqueia refresh / fechar aba
   */
  useEffect(() => {
    if (!when) return

    const handler = (e) => {
      e.preventDefault()
      e.returnValue = ''
    }

    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [when])

  function cancelLeave() {
    setVisible(false)
    setPendingLocation(null)
    setForceVisibility(false)
  }

  function leaveWithoutSaving() {
    unblockRef.current?.()
    setVisible(false)

    // Permite executar uma ação de limpeza antes de sair,
    // mantendo o usuário na rota atual.
    // Útil para limpar formulários ou restaurar o estado inicial da página
    // quando ele optar por sair sem salvar as alterações.
    if (forceVisibility && leaveWithoutSavingCleanup) return leaveWithoutSavingCleanup()

    if (pendingLocation) {
      history.push(pendingLocation)
    } else {
      history.push(leaveRoute)
    }
  }

  async function saveAndStay() {
    await saveAction()
    setVisible(false)
    setPendingLocation(null)
    setForceVisibility(false)
  }

  return (
    <Modal
      visible={visible}
      footer={null}
      onCancel={cancelLeave}
      wrapClassName="unsavedChangesModal"
      title={
        <div className="confirmModal__icon">
          <img src={AlertIcon} alt="alert" width={25} height={25} />
        </div>
      }
    >
      <div className="unsavedChangesMessage">
        <div>{getMessage('unsavedChangesTitle')}</div>
        <div>
          {getMessage('unsavedChangesWarning')}{' '}
          <span className="unsavedChangesMessage__danger">{getMessage('unsavedChangesDanger')}</span>.{' '}
          {getMessage('wantToContinue')}
        </div>
      </div>

      <div className="confirmModal__footer">
        <Button key="cancel" className="btnCancelDanger" onClick={cancelLeave}>
          {getMessage('cancel')}
        </Button>

        <Button key="exit" className="btnExitWithoutSaving" onClick={leaveWithoutSaving}>
          {getMessage('unsavedChanges')}
        </Button>

        <Button key="save" className="btnSaveChanges" loading={isSubmitting} onClick={saveAndStay}>
          {getMessage('saveChanges')}
        </Button>
      </div>
    </Modal>
  )
}
